<div class="sidePanelEndLine">
  <div class="sidePanelEndLine--inner"></div>
</div>
